import React, { useContext } from "react";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { SettingsContext } from "../../utils/settings";
import { logout } from "../../utils/logout";
import { RpfGlobalNav } from "@raspberrypifoundation/rpf-global-nav/dist";

import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";

const GlobalNav = ({ redirectToLogin = false }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const [, setCookie] = useCookies("i18next");

  const settings = useContext(SettingsContext);
  const userType = useSelector((state) => state.editor.userType);

  const editorOnLogIn = () => {
    localStorage.setItem("location", window.location.pathname);
    navigate("/auth/user_login/full");
  };

  const onLogOut = async () => {
    logout(auth);
  };

  const editorOnSignUp = () => {
    localStorage.setItem("location", window.location.pathname);
    auth.signinRedirect({
      extraQueryParams: {
        ...auth.settings?.extraQueryParams,
        login_options: "force_signup",
      },
    });
  };

  const onSelectLanguage = (lang) => {
    setCookie("i18next", lang, { path: "/", maxAge: 60 * 60 * 24 * 365 * 5 }); // 5 years
    const currentPath = location.pathname;
    // new path should replace the two or four letter language code at the start
    const newPath = currentPath.replace(/^\/[a-z]{2}(-[A-Z]{2})?/, `/${lang}`);
    navigate(newPath);
    i18n.changeLanguage(lang);
  };

  const navigateToLogin = () => {
    navigate(`/${locale}/login`);
  };

  return (
    <RpfGlobalNav
      locale={locale}
      locales={{
        en: { url: "/en", text: "English (Global)" },
        "en-US": { url: "/en-US", text: "English (US)" },
        "es-LA": { url: "/es-LA", text: "Español (Latinoamericano)" },
        "fr-FR": { url: "/fr-FR", text: "Français" },
        "ga-IE": { url: "/ga-IE", text: "Gaeilge" },
      }}
      onSelectLanguage={onSelectLanguage}
      loggedIn={!!auth.user}
      onLogOut={onLogOut}
      theme={settings.theme}
      hideAccountDropdown={userType !== "full"}
      onLogIn={redirectToLogin ? navigateToLogin : editorOnLogIn}
      onSignUp={redirectToLogin ? navigateToLogin : editorOnSignUp}
    />
  );
};

export default GlobalNav;
